export default __webpack_public_path__ + "static/media/Congratulate.74c36478.png";